module.exports = __webpack_public_path__ + "static/media/medium_4850.png.39a816dc.webp";